import React from "react"
import { Box, Container, Flex, Grid, Heading, Text } from "@theme-ui/components"
import { getPagePath } from "../utils/pathUtils"
import Link from "./link"
import SectionTitle from "./sectionTitle"
import Img from "gatsby-image"

const PageCollection = ({ title, pages }) => {
  // console.log(pages)
  return (
    <Box>
      <Container>
        <SectionTitle title={title} />
        <Grid columns={[2]} gap={"1px"}>
          {pages.map(page => (
            <PageThumb page={page} key={page.id} />
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

const PageThumb = ({ page }) => (
  <Link to={getPagePath(page)} sx={{ textDecoration: "none" }}>
    <Flex
      sx={{
        height: ["14rem", "24rem"],
        backgroundColor: "primary",
        padding: 4,
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          height: "100%",
          width: "100%",
          top: 0,
          left: 0,
          ".gatsby-image-wrapper": {
            height: "100%",
          },
        }}
      >
        <Img fluid={page.heroImage.fluid} />
      </Box>
      <Text
        variant="headingSmall"
        sx={{
          textTransform: "uppercase",
          fontWeight: "normal",
          margin: 0,
          color: "dark",
          fontSize: 3,
          zIndex: 1,
        }}
      >
        {page.title}
      </Text>
    </Flex>
  </Link>
)

export default PageCollection
